import React, {Component} from 'react';
import {InputItem, Modal, Popover, Toast,List} from 'antd-mobile';
import {userReal} from '../../service/homeService';
import "./style.less";
import storage from "../../utils/localStore";

const Item = Popover.Item;
export default class RealNameModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name:'',
            // papers:'',
            numVisible:false,
            numSelected:'身份证',
            passport:[
                {
                    "value":"身份证",
                    "desription":"身份证"
                },
                {
                    "value":"护照",
                    "desription":"护照"
                },
                {
                    "value":"边民证",
                    "desription":"边民证"
                }
            ],
            placevalue:'身份证',
            IdCard:''
        };
    }
    componentDidMount() {
        // console.log(this.props)
        this.inputHandle();
    }
    inputChange = (v, key) => {
        this.setState({[key]: v,});
    };
    realNameBtn = () => {
        if (this.state.name === '') {
            Toast.fail('请填写姓名', 2);
        } else if (this.state.IdCard === '') {
            Toast.fail('请填写证件号', 2);
        }else if (this.state.IdCard.length < 5 ) {
            Toast.fail('证件号码不能少于5位', 2);
        } else {
            Toast.loading("",0);
            let params = {
                source:1,
                token:this.props.userInfo.token,
                data:{
                    realName: this.state.name,
                    idNum: this.state.IdCard,
                    idType:this.state.placevalue == '身份证' ? 'idcard' : this.state.placevalue == '护照' ? 'passport' : "borderCard",
                }
            };
            userReal(params).then((res)=>{
                if(res.data.code === '0000'){
                    Toast.info('绑定成功',2, this.props.realNameClick(this.state.IdCard));
                    let usr = {
                        token:this.props.userInfo.token,
                        phone: this.props.userInfo.phone,
                        openid: this.props.userInfo.openid,
                        nickname:this.props.userInfo.nickname,
                        avatar:this.props.userInfo.avatar,
                        integral:this.props.userInfo.integral,
                        emergencyContact:this.props.userInfo.emergencyContact,
                        idNum:this.state.IdCard,
                        userId:this.props.userInfo.id,
                    };
                    storage.setItem('usr', usr);
                }else{
                    Toast.info(res.data.msg,3)
                }
            });
        }
    };
    onSelect = (opt) => {
        this.setState({
            numVisible: false,
            numSelected: opt.props.value,
        });
    };
    handleVisibleChange = (visible) => {
        this.setState({numVisible:visible,});
    };
    inputHandle(){
        let inputs =  document.getElementsByTagName("input");
        let selects = document.getElementsByTagName("select");
        for(let i = 0;i<inputs.length;i++){
            let item = inputs[i];
            item.addEventListener('blur',function(){
                setTimeout(function(){
                    window.scrollTo(0, 0)
                },100)
            })
        }
        for(let i = 0;i<selects.length;i++){
            let select = selects[i];
            select.addEventListener('onChange',function(){
                setTimeout(function(){
                    window.scrollTo(0, 0)
                },100)
            })
            select.addEventListener('blur',function(){
                setTimeout(function(){
                    window.scrollTo(0, 0)
                },100)
            })
        }
    }
    show_sub(e){
        this.setState({placevalue:e.target.value})
    }
    render(){
        return(
            <Modal
                // popup
                className="realNameModal"
                visible={this.props.modal}
                // onClose={() => this.props.onClose()}
            >
                <div className="content">
                    <div className="bar"></div>
                    <div className="top">实名认证</div>
                    <p>应网约车监管政策要求，乘坐网约车需要进行实名认证。</p>
                    <div className="middle">
                      {/*    <InputItem
                            clear
                            placeholder="请输入姓名"
                            value={this.state.name}
                            onChange={v => this.inputChange(v, 'name')}
                        >
                            姓名:
                        </InputItem>
                        <InputItem
                            placeholder={"请输入"+this.state.numSelected}
                            clear
                            className="idCardClass"
                            value={this.state.papers}
                            onChange={v => this.inputChange(v, 'papers')}
                            maxLength={18}
                        ><Popover
                                  overlayClassName="fortest"
                                  visible={this.state.numVisible}
                                  overlay={[
                                      (<Item key="idcard" value="身份证">身份证</Item>),
                                      (<Item key="passport" value="护照" >护照</Item>),
                                  ]}
                                  onVisibleChange={this.handleVisibleChange}
                                  onSelect={this.onSelect}
                            >
                                <div>{this.state.numSelected}<i className="icon iconfont iconxiala"/></div>
                            </Popover>
                                </InputItem>*/}
                        <div className="inputBpx">
                            <InputItem
                                placeholder="填写姓名"
                                value={this.state.name}
                                onChange={v => this.inputChange(v, 'name')}
                                onBlur={v => window.scroll(0,0)}
                            >姓名</InputItem>
                        </div>
                        <div className="inputBpx">

                            <InputItem
                                maxLength={18}
                                placeholder={"请输入"+this.state.placevalue}
                                value={this.state.IdCard}
                                className="card"
                                onChange={(val) => this.inputChange(val, 'IdCard')}
                                onBlur={v => window.scroll(0,0)}
                            >
                                <select value={this.state.placevalue} onChange={(v)=>this.show_sub(v)}>
                                    {this.state.passport.map((res,i)=>(
                                        <option key={i} value={res.value}>{res.desription}</option>
                                    ))}
                                </select>
                                <i className="icon iconfont iconxiala"/>
                            </InputItem>
                        </div>
                    </div>
                    <div className="bottom" onClick={this.realNameBtn}>下一步</div>
                </div>

            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/RealNameModal/index.js